export const sameAddress = {
  SAME_WORK: 'SAME_WORK',
  SAME_CARD: 'SAME_CARD',
  NOT_SAME: 'NOT_SAME',
}
